import React from 'react';

import { ReactComponent as DeleteIcon } from 'assets/icons/deleteIcon.svg';
import { isNull } from 'lodash';
import PropTypes from 'prop-types';

import { ActionButton } from 'components/ActionButton/ActionButton';
import { CustomTooltip } from 'components/CustomTooltip/CustomTooltip';
import { TooltipIconButton } from 'components/TooltipIconButton/TooltipIconButton';

import {
  EIV_STATUS,
  EIV_STATUS_SALES_FORCE,
  EXPERT_STATUS_ACCOUNT_CREATION,
} from 'global/constants';

export const AccountActionGuard = ({ row, onAction }) => {
  const handleClick = () => {
    onAction(row.id);
  };

  if (
    row.salesForceStatus === EIV_STATUS_SALES_FORCE.NOT_SET &&
    !isNull(row.statusAccountCreation)
  ) {
    return (
      <CustomTooltip title={row.statusAccountCreation}>
        <span>
          <ActionButton title="Konto vergeben" disabled inverted />
        </span>
      </CustomTooltip>
    );
  }

  if (row.salesForceStatus === EIV_STATUS_SALES_FORCE.NOT_SET) {
    return <ActionButton title="Konto vergeben" inverted onClick={handleClick} />;
  }

  return (
    <TooltipIconButton onClick={handleClick}>
      <DeleteIcon />
    </TooltipIconButton>
  );
};

AccountActionGuard.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    canCreateAccount: PropTypes.bool.isRequired,
    salesForceStatus: PropTypes.oneOf(Object.values(EIV_STATUS)).isRequired,
    statusAccountCreation: PropTypes.oneOf(Object.values(EXPERT_STATUS_ACCOUNT_CREATION))
      .isRequired,
  }).isRequired,
  onAction: PropTypes.func.isRequired,
};

AccountActionGuard.displayName = 'AccountActionGuard';
